import { render, staticRenderFns } from "./FatzebraCard.vue?vue&type=template&id=be5365e6&scoped=true&"
import script from "./FatzebraCard.vue?vue&type=script&lang=js&"
export * from "./FatzebraCard.vue?vue&type=script&lang=js&"
import style0 from "./FatzebraCard.vue?vue&type=style&index=0&id=be5365e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be5365e6",
  null
  
)

export default component.exports